module.exports = __webpack_public_path__ + "222dcb6bbfe740612bd501a55cffb806.jpg";